import React from 'react'
import {useTranslation} from 'react-i18next'

type Props = {
 open: boolean
 onClose: () => void
}

const AttentionModal: React.FC<Props> = ({
 open,
 onClose,
}) => {
 const {t} = useTranslation()
 if (!open) return null

 return (
  <div className='fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50'>
   <div className='relative w-[600px] rounded-3xl bg-white p-8 shadow-[0_20px_60px_rgba(0,0,0,0.2)]'>
    <button
     onClick={onClose}
     className='absolute right-5 top-5 flex h-11 w-11 items-center justify-center rounded-full bg-gray-200 text-xl font-semibold hover:bg-gray-300'
    >
     ✕
    </button>

    <h2 className='mb-6 text-3xl font-bold text-gray-900'>
     {t('modalData.attention')}
    </h2>

    <p className='mb-8 text-lg leading-relaxed text-gray-800'>
     {t('modalData.deleteWarning')}
    </p>

    <button
     onClick={onClose}
     className='w-full rounded-xl bg-green-700 py-4 text-lg font-semibold text-white hover:bg-green-800'
    >
     {t('modalData.okay')}
    </button>
   </div>
  </div>
 )
}

export default AttentionModal
